<template>
  <button
    :class="{'is-active': isActive}"
    class="hamburger hamburger--squeeze"
    type="button"
    aria-label="Кнопка меню"
    @click="$emit('click')"
  >
    <span class="hamburger-box">
      <span class="hamburger-inner"/>
    </span>
  </button>
</template>

<script>
export default {
  name: 'BaseBurger',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/BaseBurger.vue